<script setup>
/* Components */
import BackToTopIcon from './icons/BackToTopIcon.vue';

/* Handle Back To Top */
const onBackToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
</script>

<template>
  <button
    class="back-to-top-link"
    tabindex="0"
    aria-label="Back to top"
    @click="onBackToTop"
    @keydown.enter="onBackToTop"
  >
    <BackToTopIcon
      width="38"
      height="38"
    />
  </button>
</template>

<style lang="scss" scoped>
.back-to-top-link {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  cursor: pointer;
  z-index: 999;
  background: transparent;
  border: none;

  &:hover {
    filter: brightness(85%);
  }

  /* stylelint-disable declaration-block-no-duplicate-properties */
  animation: fadein 0.5s;
  animation: fadein 0.5s;
  animation: fadein 0.5s;
  animation: fadein 0.5s;
  animation: fadein 0.5s;
}

@keyframes fadein {

  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
